import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { selectCurrentEmployee } from "./reducers/config/configSlice";
import type { RootState } from "./store";

/**
 * Custom base query that automatically adds authentication headers header when a user is logged in
 */
export const createCustomBaseQuery = () => {
  return fetchBaseQuery({
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;

      // Get the current employee from the config API using the selector pattern
      const currentEmployee = selectCurrentEmployee(state);

      // Header is currently unused by the app, it's useful in the request logs though
      if (currentEmployee?.id) {
        headers.set("RadPay-Employee", currentEmployee.id.toString());
      }

      return headers;
    },
  });
};

export const baseQuery = createCustomBaseQuery();
